import { IndicatorRecordingOff } from '../../../../../assets/svg/IndicatorRecording';
import { IndicatorRecordingInProgress } from '../../../../../assets/svg/IndicatorRecordingInProgress';

interface StatusIndicatorProps {
  isActive: boolean;
}
export const StatusIndicator = ({ isActive }: StatusIndicatorProps) => {
  return (
    <div className="flex justify-center center items-center">
      {isActive ? <IndicatorRecordingInProgress /> : <IndicatorRecordingOff />}
    </div>
  );
};
